import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
  getDoneWorksAllFieldWorks: {
    apiServiceMethodName:
      ModulesConfigMap[ModulesMap.DONE_WORKS_ALL_FIELD_WORKS].GET_DONE_WORKS_ALL_FIELD_WORKS
  },
}